import * as types from "./admin.action.types";

export default {
  [types.GET_AdminUsers]: (state, res) => {
    state.GET_AdminUsers = res;
  },
};
